import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

class ImportService {
  static async uploadMetricData(standardId, period, payload) {

    return HttpUtil.post(
      API_ROUTES.KPI.IMPORT_DATA.replace("<standardId>", standardId).replace("<date>", period),
      payload
    );
  }

  static getImportStatus() {
    return HttpUtil.get(API_ROUTES.KPI.IMPORT_STATUS);
  }
}

export default ImportService;
